import React, { useEffect, useState } from 'react';
import { canPromptInstall, promptInstall, onInstallChange, isInstalled, isIOS } from '../../installPrompt';

export default function InstallCard() {
  const [, rerender] = useState(0);
  useEffect(() => onInstallChange(() => rerender((n) => n + 1)), []);

  let body;
  if (isInstalled()) {
    body = <p className="install-note">✅ You're using the installed app.</p>;
  } else if (canPromptInstall()) {
    body = (
      <button className="btn" onClick={promptInstall}>
        📲 Install app
      </button>
    );
  } else if (isIOS()) {
    body = (
      <p className="install-note">
        On iPhone or iPad, open this page in Safari, tap the Share button <b>⬆︎</b>, then
        choose <b>Add to Home Screen</b>.
      </p>
    );
  } else {
    body = (
      <p className="install-note">
        Open your browser's menu and choose <b>Install app</b> or <b>Add to Home screen</b>.
      </p>
    );
  }

  return (
    <div className="card cp" style={{ marginTop: 12 }}>
      <div className="st">📱 Put it on your home screen</div>
      <p style={{ fontSize: 12, color: 'var(--mut)', marginBottom: 12 }}>
        It opens full screen like a normal app, and payday and bill reminders can reach you.
      </p>
      {body}
    </div>
  );
}
